// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"V2-z","colorTextValue":"W2-z","swatches":"X2-z","collapseLink":"Y2-z","isCollapsed":"Z2-z","dropdown":"_2-z","disabled":"a3-z"};